export default __webpack_public_path__ + "static/media/thumbnail.24d3a8dc.png";